'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconBoldB, iconBoldBTag } from '@ni/nimble-components/dist/esm/icons/bold-b';
import { wrap } from '../../utilities/react-wrapper';

export type { IconBoldB };
export { iconBoldBTag };
export const NimbleIconBoldB = wrap(IconBoldB);